module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/diagnostic-test/diagnostic-test.component.html
// module id = ./src/app/Pages/tasks/diagnostic-test/diagnostic-test.component.html
// module chunks = main